document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.submenu-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const submenu = this.closest('.mobile-menu-item')
        .querySelector(':scope > .mobile-submenu');

      submenu.classList.toggle('active');
      this.classList.toggle('is-open');
    });
  });
});